interface SpeechBubblePreviewProps {
    text: string;
    size?: "small" | "medium" | "large";
    transparent?: boolean;
    className?: string;
}

// Static port of the app's SpeechBubble (obsessless-app/src/shared/components/SpeechBubble.tsx)
// used as a phone-sized preview of Ollie text in the db-admin Journey editors.
// framer-motion and the typing effect are intentionally dropped: a static render matches the
// final look, updates cleanly as you type, and avoids adding a dependency to db-admin.
export const SpeechBubblePreview = ({ text, className = "", size = "medium", transparent = true }: SpeechBubblePreviewProps) => {
    const sizeClasses = {
        small: "max-w-[55%] text-sm p-2",
        medium: "max-w-[70%] p-4",
        large: "max-w-[90%] text-xl p-4",
    };

    return (
        <div
            className={`font-ppmori border-2 border-osGrey-1 rounded-xl relative w-fit text-osBlack font-semibold text-balance text-center ${className} ${sizeClasses[size]} ${transparent ? "bg-transparent" : "bg-white"}`}>
            {text}
            <div
                className={`absolute -translate-x-1/2 w-3 h-3
                    bg-white border-osGrey-1 rotate-45 rounded-br-[3px]
                    bottom-0 translate-y-[7px] border-r-2 border-b-2
                    `}
                style={{ left: '50%' }}
            />
        </div>
    );
};
